// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig : {
    apiKey: "AIzaSyBzSPOy3V0gHT74KM2VbdgTrS3lXbQ45VQ",
    authDomain: "projectdrestein-8de88.firebaseapp.com",
    databaseURL: "https://projectdrestein-8de88.firebaseio.com",
    projectId: "projectdrestein-8de88",
    storageBucket: "",
    messagingSenderId: "539414626341",
    appId: "1:539414626341:web:5ba91605e4ebcfe2"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
